import React from 'react'
import classnames from 'classnames'

import { followStoreLink$ } from '../navigation'

import style from './PayMeYouLinkCard.module.scss'

export default function PayMeYouLinkCard({ link, index }) {
  const isReusable = link.get('isReusable')

  return (
    <button
      className={classnames(
        style.card,
        `js-pay-me-you-card-${index} legacyCard`
      )}
      onClick={() => followStoreLink$.next(link.get('detailUrl'))}
    >
      <div className={style.content}>
        <span className={classnames(style.cardLabel, 'js-link-label')}>
          {isReusable ? `${link.get('friendlyGroup')}` : `${link.get('label')}`}
        </span>
        <span className={style.subContent}>
          <span
            className={classnames(
              style.generationDateLabel,
              'js-generation-date'
            )}
          >
            Generated
          </span>
          <span
            className={classnames(style.generationDate, 'js-generation-date')}
          >
            {link.get('dateText')}
          </span>
        </span>
        <span className={style.subContent}>
          {isReusable ? (
            <span className={classnames(style.viewDetails, 'js-view-details')}>
              View details
            </span>
          ) : (
            <span className={classnames(style.amount, 'js-amount')}>
              {link.get('amountString')}
            </span>
          )}
        </span>
      </div>
    </button>
  )
}
